import { CircleCheck } from "lucide-react";
import { ABOUT, IMG } from "@/data/content";
import { Reveal } from "@/lib/motion";
import RevealImage from "@/components/RevealImage";

export default function About() {
    return (
        <section id="apropos" className="py-24 md:py-32 bg-white relative" data-testid="about-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-2 gap-16 items-center">
                    <Reveal className="relative" y={0}>
                        <RevealImage src={IMG.about} alt="Espace professionnel impeccable" className="h-[520px]" aspect="" priority testid="about-image" />
                        <div className="absolute -bottom-6 -right-6 bg-navy text-white p-8 hidden md:block">
                            <div className="text-4xl font-light font-display">{ABOUT.stat.value}</div>
                            <div className="text-xs uppercase tracking-[0.2em] mt-1 font-body text-electric-soft">{ABOUT.stat.label}</div>
                        </div>
                    </Reveal>

                    <div>
                        <Reveal><span className="uppercase text-xs tracking-[0.2em] font-bold text-brand-red font-body">{ABOUT.kicker}</span></Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-navy mt-4 mb-6 font-display">
                                {ABOUT.title[0]}<br />{ABOUT.title[1]}
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}><div className="h-px w-16 bg-brand-red mb-8" /></Reveal>
                        <Reveal delay={0.12}><p className="text-base leading-relaxed text-slate-500 mb-6 font-body">{ABOUT.p1}</p></Reveal>
                        <Reveal delay={0.16}>
                            <blockquote className="border-l-4 border-brand-red pl-6 py-2 mb-8" data-testid="about-quote">
                                <p className="text-lg font-medium text-navy italic font-display">&ldquo;{ABOUT.quote}&rdquo;</p>
                            </blockquote>
                        </Reveal>
                        <Reveal delay={0.2}><p className="text-base leading-relaxed text-slate-500 mb-8 font-body">{ABOUT.p2}</p></Reveal>
                        <div className="space-y-4">
                            {ABOUT.points.map((p, i) => (
                                <Reveal key={p} delay={0.24 + i * 0.05} className="flex items-start gap-3">
                                    <CircleCheck className="w-5 h-5 text-brand-red mt-0.5 flex-shrink-0" />
                                    <span className="text-sm font-medium text-slate-700 font-body">{p}</span>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
